import {generateBaseURL, generateBaseURLWebSocket} from "../axios.config";
import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {IFavoriteDeleteItem, IGetPrecisions, IGetPrecisionsArgs, ITOHistory, ITOHistoryWithId} from "../../types";
import {getState, RootState, store} from "../store";
import {makeQueryParamString} from "../../utils";
import {startTransition} from "react";
import {useSelector} from "react-redux";
import {selectors} from "../selectors";

// const futures_ex = ['BinanceFutures', 'BitgetFutures', 'ByBitFutures', 'GateIoFutures', 'HuobiFutures', 'KucoinFutures', 'MEXCFutures']

export const toFlowApi = createApi({
  // baseQuery: fetchBaseQuery({baseUrl: generateBaseURL('https')}),
  baseQuery: fetchBaseQuery({baseUrl: generateBaseURL()}),
  reducerPath: 'toFlowApi',
  endpoints: (builder) => ({
    getPrecisions: builder.query<
        IGetPrecisions,
        IGetPrecisionsArgs
    >({
      query: (args: {
        first_ex: string,
        second_ex: string,
        first_market: string,
        second_market: string,
      }) => {
        const paramString = makeQueryParamString(args)
        return `/main/precisions?${paramString}`
      }
    }),
    getToFlow: builder.query<
        ITOHistory[],
        // ITOHistoryWithId[],
        // undefined
        {
          // hiddenExchanges?: string[]
          hiddenExchanges?: string[]
          hideLowerThan?: number
          highlightFrom?: number
          filterPercent?: number
          substructFee?: number
          favorites?: IFavoriteDeleteItem[]
          deleted?: IFavoriteDeleteItem[]
        }
    >({
      query: () => '/main',
      async onCacheEntryAdded(
          // undefined,
          {
            // hideNumFilter,
            // feeFilter,
            hiddenExchanges,
            hideLowerThan,
            highlightFrom,
            filterPercent,
            substructFee,
            favorites,
            deleted
          },
          // : {
          //   // hideNumFilter?: number
          //   // feeFilter?: number
          //   hiddenExchanges?: string[]
          //   hideLowerThan?: number
          //   highlightFrom?: number
          //   filterPercent?: number
          //   substructFee?: number
          //   favorites?: string[]
          //   deleted?: string[]
          // },
          {updateCachedData, cacheDataLoaded, cacheEntryRemoved}
      ) {
        let ws: WebSocket | null = null
        let shouldReconnect = true
        let reconnectTimeout: NodeJS.Timeout | null = null
        let buffer: ITOHistory[] = []
        let rafScheduled = false
        // let feeFilter: number
        // let hideNumFilter: number
        // // let highlightFrom: number
        // let percentFilter: number
        // let hiddenExchangesSet = new Set<string>()

        // store.subscribe(() => {
        //   const calc = store.getState().calc
        //   feeFilter = calc.feeFilter
        //   hideNumFilter = calc.hideNumFilter
        //   // highlightFrom = calc.highlightFrom
        //   percentFilter = calc.filterPercent
        //   hiddenExchangesSet = new Set(calc.hiddenExchanges)
        //   // hiddenExchanges = calc.hiddenExchanges
        // })

        // const shouldPass = (f: ITOHistory, getState: () => RootState): boolean => {
        // const shouldPass = (f: ITOHistory): boolean => {
        //   // const { feeFilter, hideNumFilter, hiddenExchanges } = getState().calc
        //   const profit = f.pure_profit ?? 0
        //   // if (hiddenExchanges && (hiddenExchanges.includes(f.first_ex) || hiddenExchanges.includes(f.second_ex))) {
        //   //   return false
        //   // }
        //   if (
        //       hiddenExchangesSet.has(f.first_ex) ||
        //       hiddenExchangesSet.has(f.second_ex)
        //   ) {
        //     return false
        //   }
        //   return !(hideNumFilter && profit <= hideNumFilter);
        // }
        // const shouldPass = (f: ITOHistory): boolean => {
        //   if (hiddenExchangesSet.has(f.first_ex) || hiddenExchangesSet.has(f.second_ex)) {
        //     return false
        //   }
        //
        //   return f.pure_profit > hideNumFilter
        // }

        // const shouldPass = (f: ITOHistory): boolean => {
        //   const { feeFilter, hideNumFilter, hiddenExchanges } = getState().calc
        //   const profit = f.pure_profit ?? 0
        //   if (hiddenExchanges && (hiddenExchanges.includes(f.first_ex) || hiddenExchanges.includes(f.second_ex))) {
        //     return false
        //   }
        //   if (futures_ex.includes(f.first_ex) || futures_ex.includes(f.second_ex)) {
        //     return false
        //   }
        //   return !(typeof hideNumFilter === 'number' && profit <= hideNumFilter);
        // }

        const BUFFER_CAP = 60

        const flush = () => {
          if (buffer.length === 0) {
            rafScheduled = false
            return
          }
          const batch = buffer.reverse()
          buffer = []
          updateCachedData(draft => [...batch, ...draft].slice(0, 60) as typeof draft)
          rafScheduled = false
        }

        const onMessage = (evt: MessageEvent<string>) => {
          if (document.hidden) {
            buffer = []
            return
          }
          const data = JSON.parse(evt.data) as ITOHistory

          if (buffer.length >= BUFFER_CAP) buffer.shift()
          // if (!shouldPass(data, getState )) return
          // if (!shouldPass(data)) return

          buffer.push(data)

          if (!rafScheduled) {
            rafScheduled = true
            requestAnimationFrame(flush)
          }

        }

        const onVisibilityChange = () => {
          if (!document.hidden) {
            buffer = []
          }
        }
        document.addEventListener('visibilitychange', onVisibilityChange)

        const cleanup = () => {
          shouldReconnect = false
          document.removeEventListener('visibilitychange', onVisibilityChange)

          if (reconnectTimeout) {
            clearTimeout(reconnectTimeout)
            reconnectTimeout = null
          }

          if (ws) {
            ws.onopen = null
            ws.onmessage = null
            ws.onerror = null
            ws.onclose = null

            if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
              try {
                ws.close(3337, 'Close or reconnect session')
              } catch (error) {
                console.error('Error closing WebSocket:', error)
              }
            }
            ws = null
          }
        }

        try {
          await cacheDataLoaded

          const connect = () => {
            if (!shouldReconnect) return

            // ws = new WebSocket(generateBaseURLWebSocket('wss'))
            ws = new WebSocket(generateBaseURLWebSocket())
            let reconnectAttempt = 0

            ws.onopen = () => {
              if (!shouldReconnect) {
                cleanup()
                return
              }

              reconnectAttempt = 0

              ws!.send(
                  JSON.stringify({
                    type: 'subscription',
                    topic: 'toFlow',
                    channel: 'history',
                    params: {
                      // hidden_lower_than: hideLowerThan && hideLowerThan > 0 ? hideLowerThan : undefined,
                      // highlight_from: highlightFrom && highlightFrom > 0 ? highlightFrom : undefined,
                      // filter_percent: percentFilter && percentFilter > 0 ? percentFilter : undefined,
                      // hide_exchanges: hiddenExchanges,
                      // favorite: Option<Vec<WsSubscribeParamFavDel>>,
                      // deleted: Option<Vec<WsSubscribeParamFavDel>>,
                      hidden_lower_than: hideLowerThan === 0 ? undefined : hideLowerThan,
                      highlight_from: highlightFrom === 0 ? undefined : highlightFrom,
                      filter_percent: filterPercent === 0 ? undefined : filterPercent,
                      hide_exchanges: hiddenExchanges,
                      favorite: favorites,
                      deleted: deleted,
                    }
                  })
              )
            }

            ws.onmessage = onMessage

            ws.onerror = error => {
              console.error('WebSocket error:', error)
            }

            ws.onclose = (event: CloseEvent) => {
              if (event.code === 3337 || !shouldReconnect) {
                return
              }
              reconnectAttempt++
              const delay = Math.min(1000 * Math.pow(2, reconnectAttempt), 10000)

              console.log(`WebSocket closed. Reconnecting in ${delay}ms...`)

              reconnectTimeout = setTimeout(() => {
                if (shouldReconnect) {
                  connect()
                }
              }, delay)
            }
          }

          connect()

          await cacheEntryRemoved
          cleanup()
        } catch (e: any) {
          console.error('Error in onCacheEntryAdded:', e.message)
          cleanup()
        }
      },
      keepUnusedDataFor: 30,
    }),
  }),
})

// export const toFlowApi = createApi({
//   baseQuery: fetchBaseQuery({baseUrl: generateBaseURL(3337, 'https')}), //todo
//   reducerPath: 'toFlowApi',
//   endpoints: (builder) => ({
//     getPrecisions: builder.query<
//         IGetPrecisions,
//         IGetPrecisionsArgs
//     >({
//       query: (args: {
//         first_ex: string,
//         second_ex: string,
//         first_market: string,
//         second_market: string,
//       }) => {
//         const paramString = makeQueryParamString(args)
//         console.log(paramString)
//         return `/main/precisions?${paramString}`
//       }
//     }),
//     getToFlow: builder.query<
//         ITOHistoryWithId[],
//         undefined
//     >({
//       query: () => '/main',
//       async onCacheEntryAdded(
//           undefined,
//           // {
//           //   hideNumFilter,
//           //   feeFilter,
//           //   hiddenExchanges,
//           // }: {
//           //   hideNumFilter?: number
//           //   feeFilter?: number
//           //   hiddenExchanges?: string[]
//           // },
//           {updateCachedData, cacheDataLoaded, cacheEntryRemoved}
//       ) {
//         ///todo me newest
//
//         // let ws: WebSocket | null = null
//         //
//         // const shouldPass = (f: ITOHistory, getState: () => RootState): boolean => {
//         //   const { feeFilter, hideNumFilter, hiddenExchanges } = getState().calc
//         //   const profit = f.pure_profit ?? 0
//         //   if (hiddenExchanges && (hiddenExchanges.includes(f.first_ex) || hiddenExchanges.includes(f.second_ex))) {
//         //     return false
//         //   }
//         //   if (futures_ex.includes(f.first_ex) || futures_ex.includes(f.second_ex)) {
//         //     return false
//         //   }
//         //   return !(typeof hideNumFilter === 'number' && profit <= hideNumFilter);
//         // }
//         //
//         // let shouldReconnect = true
//         // let reconnectTimeout: NodeJS.Timeout | null = null
//         // let buffer: ITOHistoryWithId[] = []
//         // let flushTimeout: NodeJS.Timeout | null = null
//         // const MAX_ITEMS = 30
//         //
//         // const flush = () => {
//         //   if (buffer.length === 0) return
//         //   updateCachedData(draft => {
//         //
//         //     draft.push(...buffer)
//         //
//         //     if (draft.length > MAX_ITEMS) {
//         //       draft.splice(0, draft.length - MAX_ITEMS)
//         //     }
//         //   })
//         //   buffer = []
//         // }
//         //
//         //
//         // const scheduleFlush = () => {
//         //   if (flushTimeout) return
//         //
//         //   flushTimeout = setTimeout(() => {
//         //     flush()
//         //     flushTimeout = null
//         //   // }, 120) // ~8fps
//         //   }, 100) // ~10fps
//         // }
//         //
//         // const onMessage = (evt: MessageEvent<string>) => {
//         //   const data = JSON.parse(evt.data) as ITOHistory
//         //   if (!shouldPass(data, getState )) return
//         //   buffer.push({
//         //     ...data,
//         //     _id: crypto.randomUUID()
//         //   })
//         //   scheduleFlush()
//         // }
//
//         ///todo my old
//
//         let ws: WebSocket | null = null
//         let shouldReconnect = true
//         let reconnectTimeout: NodeJS.Timeout | null = null
//         let buffer: ITOHistoryWithId[] = []
//         let rafScheduled = false
//         let lastFlush = 0
//         let flushTimeout: NodeJS.Timeout | null = null
//
//         const shouldPass = (f: ITOHistory): boolean => {
//           const { feeFilter, hideNumFilter, hiddenExchanges } = getState().calc
//           const profit = f.pure_profit ?? 0
//           if (hiddenExchanges && (hiddenExchanges.includes(f.first_ex) || hiddenExchanges.includes(f.second_ex))) {
//             return false
//           }
//           if (futures_ex.includes(f.first_ex) || futures_ex.includes(f.second_ex)) {
//             return false
//           }
//           return !(typeof hideNumFilter === 'number' && profit <= hideNumFilter);
//         }
//
//         // const flush = () => {
//         //   updateCachedData(draft => {
//         //     draft.push(...buffer)
//         //
//         //     if (draft.length > 40) {
//         //       draft.splice(0, draft.length - 40)
//         //     }
//         //
//         //     buffer = []
//         //   })
//         //
//         //   rafScheduled = false
//         // }
//
//         const flush = () => {
//           startTransition(() => {
//             updateCachedData(draft => {
//               draft.push(...buffer)
//
//               if (draft.length > 40) {
//                 draft.splice(0, draft.length - 40)
//               }
//
//               buffer = []
//             })
//           })
//
//           rafScheduled = false
//         }
//         const scheduleFlush = () => {
//           if (flushTimeout) return
//
//           flushTimeout = setTimeout(() => {
//             flush()
//             flushTimeout = null
//           // }, 100) // 10 fps
//           }, 50) // 20 fps
//         }
//
//         // const flush = () => {
//         //   const now = performance.now()
//         //
//         //   if (now - lastFlush < 80) {   // ~12fps
//         //     rafScheduled = false
//         //     return
//         //   }
//         //
//         //   lastFlush = now
//         //
//         //   startTransition(() => {
//         //     updateCachedData(draft => {
//         //       draft.push(...buffer)
//         //       if (draft.length > 40) {
//         //         draft.splice(0, draft.length - 40)
//         //       }
//         //       buffer = []
//         //     })
//         //   })
//         //   rafScheduled = false
//         // }
//
//         // const scheduleFlush = () => {
//         //   if (flushTimeout) return
//         //
//         //   flushTimeout = setTimeout(() => {
//         //     flush()
//         //     flushTimeout = null
//         //   // }, 120) // ~8fps
//         //   }, 50) // ~20fps
//         // }
//
//         const onMessage = (evt: MessageEvent<string>) => {
//           const data = JSON.parse(evt.data) as ITOHistory
//           if (!shouldPass(data)) return
//           buffer.push({
//             ...data,
//             // _id: crypto.randomUUID()
//             _id: data.timestamp + data.market + data.pure_profit + data.first_ex + data.second_ex
//           })
//           scheduleFlush()
//             // scheduleFlush()
//           // if (!rafScheduled) {
//           //   rafScheduled = true
//           //   requestAnimationFrame(flush)
//           // }
//         }
//         // const onMessage = (evt: MessageEvent<string>): void => {
//         //   try {
//         //     const to_flow = JSON.parse(evt.data) as ITOHistory
//         //     // if (data.type !== 'TradeOptionHistory') return
//         //     // const u = data.update
//         //     if (!shouldPass(to_flow)) return
//         //
//         //
//         //     updateCachedData((draft: ITOHistory[]) => {
//         //       // const id = (data as any)._id ?? `${u.firstEx}-${u.secondEx}-${u.market}`
//         //       // const existsIdx = draft.findIndex(x => (x as any)._id === id)
//         //       // if (existsIdx !== -1) draft.splice(existsIdx, 1)
//         //       // ;(u as any)._id = id
//         //       draft.unshift(to_flow)
//         //       if (draft.length > 80) draft.splice(50)
//         //     })
//         //   } catch (error) {
//         //     console.error(`Error parsing WebSocket message:`, error)
//         //   }
//         // }
//
//         const cleanup = () => {
//           shouldReconnect = false
//
//           if (reconnectTimeout) {
//             clearTimeout(reconnectTimeout)
//             reconnectTimeout = null
//           }
//
//           if (ws) {
//             ws.onopen = null
//             ws.onmessage = null
//             ws.onerror = null
//             ws.onclose = null
//
//             if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
//               try {
//                 ws.close(3337, 'Close or reconnect session')
//               } catch (error) {
//                 console.error('Error closing WebSocket:', error)
//               }
//             }
//             ws = null
//           }
//         }
//
//         try {
//           await cacheDataLoaded
//
//           const connect = () => {
//             if (!shouldReconnect) return
//
//             ws = new WebSocket(generateBaseURLWebSocket(8087, 'wss'))
//             let reconnectAttempt = 0
//
//             ws.onopen = () => {
//               if (!shouldReconnect) {
//                 cleanup()
//                 return
//               }
//
//               reconnectAttempt = 0
//
//               ws!.send(
//                   JSON.stringify({
//                     type: 'subscription',
//                     topic: 'toFlow',
//                     channel: 'history'
//                   })
//               )
//             }
//
//             ws.onmessage = onMessage
//
//             ws.onerror = error => {
//               console.error('WebSocket error:', error)
//             }
//
//             ws.onclose = (event: CloseEvent) => {
//               if (event.code === 3337 || !shouldReconnect) {
//                 return
//               }
//
//               reconnectAttempt++
//               const delay = Math.min(1000 * Math.pow(2, reconnectAttempt), 10000)
//
//               console.log(`WebSocket closed. Reconnecting in ${delay}ms...`)
//
//               reconnectTimeout = setTimeout(() => {
//                 if (shouldReconnect) {
//                   connect()
//                 }
//               }, delay)
//             }
//           }
//
//           connect()
//
//           await cacheEntryRemoved
//           cleanup()
//         } catch (e: any) {
//           console.error('Error in onCacheEntryAdded:', e.message)
//           cleanup()
//         }
//       },
//       keepUnusedDataFor: 30,
//     }),
//   }),
// })

//  hidden_lower_than: Option<f64>,
//   highlight_from: Option<f64>,
//   filter_percent: Option<f64>,
//   hide_exchanges: Option<Vec<String>>,
//   favorite: Option<Vec<WsSubscribeParamFavDel>>,
//   deleted: Option<Vec<WsSubscribeParamFavDel>>,


export const { useGetToFlowQuery, useLazyGetPrecisionsQuery } = toFlowApi;